var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.625 21.75V0.75H3.375V21.75H0.75V23.25H23.25V21.75H20.625ZM19.125 21.75H12.75V18.75H11.25V21.75H4.875V2.25H19.125V21.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.25H9V15.75H7.5V14.25ZM11.25 14.25H12.75V15.75H11.25V14.25ZM15 14.25H16.5V15.75H15V14.25ZM7.5 9.75H9V11.25H7.5V9.75ZM11.25 9.75H12.75V11.25H11.25V9.75ZM15 9.75H16.5V11.25H15V9.75ZM7.5 5.25H9V6.75H7.5V5.25ZM11.25 5.25H12.75V6.75H11.25V5.25ZM15 5.25H16.5V6.75H15V5.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.10249e7f288de6b9c43fcc6f9e7a4618.svg";
export { ForwardRef as ReactComponent };